import Swiper from "swiper";
import { Navigation, Pagination, A11y } from "swiper/modules";

const initPartnersSwiper = () => {
    const swiperContainer = document.querySelector(".partners__inner");
    if (!swiperContainer) return;

    let swiper;
    new ResizeObserver(() => {
        if (window.innerWidth < 1024) {
            if (!swiper || swiper.destroyed) {
                swiper = new Swiper(swiperContainer, {
                    slidesPerView: 1.2,
                    spaceBetween: 20,
                    modules: [Navigation, Pagination, A11y],
                    navigation: {
                        nextEl: ".partners__nav-next",
                        prevEl: ".partners__nav-prev",
                    },

                    breakpoints: {
                        480: {
                            slidesPerView: 1.5,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 1.8,
                            spaceBetween: 20,
                        },
                        1024: {
                            enabled: false,
                            spaceBetween: 0,
                            slidesPerView: "auto",
                        },
                    },
                });
            }
        } else if (swiper) {
            swiper.destroy();
        }
    }).observe(swiperContainer);
};

document.addEventListener("DOMContentLoaded", initPartnersSwiper);
